import React from 'react';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';

const ConversionStatus = ({ status, error }) => {
  if (status === 'processing') {
    return (
      <Alert data-testid="status-processing" className="border-blue-200 bg-blue-50 mb-8">
        <Loader2 className="h-5 w-5 text-blue-600 animate-spin" />
        <AlertTitle className="text-blue-900 font-semibold">Processing</AlertTitle>
        <AlertDescription className="text-blue-700">
          Converting your PDF documents to Excel format. This may take a moment...
        </AlertDescription>
      </Alert>
    );
  }

  if (status === 'completed') {
    return (
      <Alert data-testid="status-completed" className="border-green-200 bg-green-50 mb-8">
        <CheckCircle2 className="h-5 w-5 text-green-600" />
        <AlertTitle className="text-green-900 font-semibold">Conversion Completed</AlertTitle>
        <AlertDescription className="text-green-700">
          Your Excel file is ready for download. Preview the data below before downloading.
        </AlertDescription>
      </Alert>
    );
  }

  if (status === 'failed') {
    return (
      <Alert data-testid="status-failed" className="border-red-200 bg-red-50 mb-8">
        <XCircle className="h-5 w-5 text-red-600" />
        <AlertTitle className="text-red-900 font-semibold">Conversion Failed</AlertTitle>
        <AlertDescription className="text-red-700">
          {error || 'An error occurred during conversion. Please try again or contact support.'}
        </AlertDescription>
      </Alert>
    );
  }

  return null;
};

export default ConversionStatus;
